module.exports = __webpack_public_path__ + "media/images/antara1_star square-a929d077363bc495983fd24689ed500c.png";